import AppCard from './AppCard.view';

export default AppCard;
